import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);

// 适配flex
import '@/common/flexible.js';

import Icon from 'vue-awesome/components/Icon';
Vue.component('icon', Icon);

//引入echart
import echarts from 'echarts'
//引入liquidfill
import 'echarts-liquidfill'
Vue.prototype.$echarts = echarts

import ElementUI from 'element-ui' 
import 'element-ui/lib/theme-chalk/index.css' 
Vue.use(ElementUI)

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
const vm = new Vue()
vm.$jsonp('/some-jsonp-url', {
  myCustomUrlParam: 'veryNice'
})

Vue.config.productionTip = false

import BaiduMap from "vue-baidu-map"
Vue.use(BaiduMap,{
    ak:'2KDU3gQN5vTQGhVsEmMdyiYkxuQUWdVN'
})

new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
